import { useMemo } from 'react';
import { getDriverSession } from '../../lib/driverSession';
import { drawingFor, useVehicleTypes } from '../../lib/useVehicleTypes';

/**
 * The signed-in rider's own vehicle on a map (Rio, 2 Oct 2026: "Their own
 * vehicle only"): the kind from the session, which carries it in words
 * ("Tuk-Tuk"), a motorbike when it names none we draw; and the phone's
 * position as one object until it moves, turned to the phone's heading and
 * stamped with the fix's own time: the glide learns the speed from it, and
 * a stamp taken on arrival made a cached fix and the next one read as a
 * jump, the vehicle overshooting and reversing (Chrome, 3 Oct 2026).
 *
 * @param {{ located: boolean, lat: number | null, lng: number | null, headingDeg: number | null, fixAt?: number | null }} live
 * @returns {{ vehicle: string, position: { lat: number, lng: number, heading: number | null, at?: number } | null }}
 */
export function useOwnVehicle(live) {
  // The drawing the office chose for the rider's vehicle type (Rio, 4 Oct 2026: the office adds types).
  const { vehicles: types } = useVehicleTypes();
  const vehicle = useMemo(() => drawingFor(getDriverSession()?.vehicle_type, types), [types]);
  const lat = live.located ? live.lat : null;
  const lng = live.located ? live.lng : null;
  const heading = Number.isFinite(live.headingDeg) ? live.headingDeg : null;
  const at = Number.isFinite(live.fixAt) ? live.fixAt : undefined;
  const position = useMemo(() => (lat != null && lng != null ? { lat, lng, heading, at } : null), [lat, lng, heading, at]);

  return { vehicle, position };
}
